import { currentDayString, User } from '@nextforce/api'
import { Button, Icon, makeStyles, Text } from '@rneui/themed'
import { font } from 'app/theme'
import { Route } from 'home/stack/types'
import React from 'react'
import { FlatList, View } from 'react-native'
import { Badge } from 'shared/components/user/badge_counter'
import { HomeItem } from '../types'
import { ItemTile } from './tiles/items'

type Props = {
  items: HomeItem[]
  user?: User
  welcomeText: string
  onTilePress(route: Route, params?: object): void
  onReplayEffect(): void
}

export function TileList({
  items,
  onTilePress,
  user,
  welcomeText,
  onReplayEffect,
}: Props) {
  const styles = useStyles()
  return (
    <FlatList
      style={styles.container}
      contentContainerStyle={styles.contentContainer}
      data={items}
      keyExtractor={(item, index) => String(item.route.name) + index}
      renderItem={({ item }) => {
        let badgeCount: number | undefined
        if ('summary' in item) {
          badgeCount = item.summary.badgeCount
        }
        return (
          <View style={styles.itemContainer}>
            <View style={styles.titleContainer}>
              <Text style={styles.title}>{item.title}</Text>
              <Badge value={badgeCount} />
            </View>
            <ItemTile
              item={item}
              onPress={params => onTilePress(item.route, params ?? item.params)}
            />
          </View>
        )
      }}
      showsVerticalScrollIndicator={false}
      ListHeaderComponent={
        <View style={styles.welcomeTextContainer}>
          <Text style={styles.welcomeText}>
            {user?.customMessage ??
              getWelcomeMessage(welcomeText, user?.firstName)}
          </Text>
          {user?.customScreenEffect ? (
            <Button
              icon={
                <Icon name={'undo-alt'} type="font-awesome-5" solid size={15} />
              }
              onPress={onReplayEffect}
              buttonStyle={{
                backgroundColor: 'transparent',
              }}
            />
          ) : (
            <></>
          )}
        </View>
      }
    />
  )

  function getWelcomeMessage(message: string, firstName?: string) {
    const welcomeMessage = message
      .replace('{FIRST_NAME}', firstName ?? '')
      .replace('{DAY_NAME}', currentDayString())

    return welcomeMessage
  }
}

const useStyles = makeStyles(theme => ({
  container: {
    flex: 1,
  },
  contentContainer: {
    paddingBottom: 100,
  },
  itemContainer: {
    marginHorizontal: 16,
  },
  welcomeTextContainer: {
    marginHorizontal: 16,
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center',
    marginTop: 24,
    marginBottom: 8,
  },
  title: {
    fontFamily: font.bold,
    fontSize: 16,
  },
  welcomeText: {
    fontSize: 22,
    fontFamily: font.bold,
    marginTop: 16,
    paddingBottom: 10,
    marginBottom: 5,
  },
}))
